import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import reduxStore from './Redux/store';
import App from './Application/App';
import registerServiceWorker from './registerServiceWorker';
import './Utilities/Gnural/websockets'; 
//import './index.css';

ReactDOM.render(<Provider store={reduxStore}><App/></Provider>, document.getElementById('root'));
registerServiceWorker();
